var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "course-card",
      on: {
        click: function ($event) {
          return _vm.$emit("click", _vm.course)
        },
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "course-card__cover",
          class: "course-card__cover--" + _vm.coverCategory,
        },
        [
          _vm.coverImage
            ? _c("img", {
                staticClass: "course-card__cover-image",
                attrs: { src: _vm.coverImage, alt: "" },
              })
            : _c("span", { staticClass: "course-card__icon" }, [
                _vm._v(_vm._s(_vm.coverIcon)),
              ]),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "course-card__body" }, [
        _c("h3", { staticClass: "course-card__title" }, [
          _vm._v(_vm._s(_vm.courseTitle)),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "course-card__meta" }, [
          _c("span", [
            _vm._v(
              _vm._s(_vm.course.hours) + " " + _vm._s(_vm.$t("common.hours"))
            ),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "course-card__sep" }, [_vm._v("·")]),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.langLabel))]),
        ]),
        _vm._v(" "),
        _vm.course.categoryLabel
          ? _c("div", { staticClass: "course-card__category" }, [
              _vm._v(_vm._s(_vm.course.categoryLabel)),
            ])
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }